<template>
  <tr v-if="!isMob">
    <td class="_photo">
      <div class="account-tab-item__photo">
        <picture class="account-tab-item__photo-wrap">
          <img src="https://thispersondoesnotexist.com/image" alt="photo">
        </picture>
        <div class="account-tab-item__photo-caption">
          <span>+4</span>&nbsp;
          <BaseSvg name="ico-photo-2"/>
        </div>
      </div>
    </td>

    <td class="_categories">
      <div class="categories-list-2">
        <div class="categories-list-2__inner">
          <div class="categories-list-2__item"
             v-for="index in 10"
             :key="index"><span>dasdasd</span></div>
        </div>
      </div>
    </td>

    <td class="_date">
      <div class="account-tab-item__date">23.01.2020</div>
    </td>

    <td class="_sent">
      <div class="account-tab-item__sent select-dropdown">
        <span class="account-tab-item__sent-number">14</span>
        <span class="account-tab-item__sent-times">{{$tGlobal('times', 14)}}</span>
        <a href="#" class="account-tab-item__sent-history-trigger" @click.prevent="showHistory = true">
          <span>{{$tResumeList('History')}}</span>
          <BaseSvg name="ico-arrow-down"/>
        </a>

        <transition name="dropdown">
          <div
            v-if="showHistory"
            v-click-out="() => this.showHistory = false"
            class="select-dropdown__dropdown"
          >
            <button
              type="button"
              class="select-dropdown__close"
              @click.prevent="showHistory = false"
            >
              <BaseSvg
                name="ico-close"
                width=".8rem"
                height=".8rem"
              />
            </button>

            <div class="select-dropdown__options">
              <ul class="account-tab-item__sent-history">
                <li v-for="index in 5"
                    :key="index"
                >
                  <a href="#" class="account-tab-item__sent-history-link">Работник на склад лампочек Philips во
                    Вроцлав</a>
                  <div class="account-tab-item__sent-history-date">{{$tResumeList('Sent')}} 19.12.2019</div>
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>
    </td>

    <td class="_action">
      <a href="#"
         class="account-tab-item__btn base-btn base-btn--outline-grey--green base-btn--small">
        <span>{{$tResumeList('Find vacancies')}}</span>
      </a>
    </td>

    <td class="_tools">
      <div class="account-tab-item__tools select-dropdown">
        <button type="button" class="account-tab-item__tools-trigger" @click.prevent="showTools = true">
          <BaseSvg name="ico-dots-2"/>
        </button>
        <transition name="dropdown">
          <div
            v-if="showTools"
            v-click-out="() => this.showTools = false"
            class="select-dropdown__dropdown"
          >
            <button
              type="button"
              class="select-dropdown__close"
              @click.prevent="showTools = false"
            >
              <BaseSvg
                name="ico-close"
                width=".8rem"
                height=".8rem"
              />
            </button>

            <div class="select-dropdown__options">
              <ul class="account-tab-item__tools-list">
                <li>
                  <button type="button" class="account-tab-item__tools-btn">
                    <BaseSvg
                      name="ico-edit"
                    />
                    <span>{{$tResumeList('Edit')}}</span>
                  </button>
                </li>
                <li>
                  <button type="button" class="account-tab-item__tools-btn">
                    <BaseSvg
                      name="ico-bin"
                    />
                    <span>{{$tResumeList('Delete')}}</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>
    </td>
  </tr>
  <div v-else class="account-tab-item__group-item">
    <div class="account-tab-item__tools select-dropdown">
      <button type="button" class="account-tab-item__tools-trigger" @click.prevent="showTools = true">
        <BaseSvg name="ico-dots-2"/>
      </button>
      <transition name="dropdown">
        <div
          v-if="showTools"
          v-click-out="() => this.showTools = false"
          class="select-dropdown__dropdown"
        >
          <button
            type="button"
            class="select-dropdown__close"
            @click.prevent="showTools = false"
          >
            <BaseSvg
              name="ico-close"
              width=".8rem"
              height=".8rem"
            />
          </button>

          <div class="select-dropdown__options">
            <ul class="account-tab-item__tools-list">
              <li>
                <button type="button" class="account-tab-item__tools-btn">
                  <BaseSvg
                    name="ico-edit"
                  />
                  <span>{{$tResumeList('Edit')}}</span>
                </button>
              </li>
              <li>
                <button type="button" class="account-tab-item__tools-btn">
                  <BaseSvg
                    name="ico-bin"
                  />
                  <span>{{$tResumeList('Delete')}}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </transition>
    </div>
    <div class="account-tab-item__group-item-top">
      <div class="account-tab-item__photo">
        <picture class="account-tab-item__photo-wrap">
          <img src="https://thispersondoesnotexist.com/image" alt="photo">
        </picture>
        <div class="account-tab-item__photo-caption">
          <span>+4</span>&nbsp;
          <BaseSvg name="ico-photo-2"/>
        </div>
      </div>
      <div class="account-tab-item__group-item-top-col">
        <div class="account-tab-item__label-mob">{{$tResumeList('Interesting vacancies')}}</div>
        <div class="categories-list-2">
          <div class="categories-list-2__inner">
            <div class="categories-list-2__item"
                 v-for="index in 10"
                 :key="index"><span>dasdasd</span></div>
          </div>
        </div>
      </div>
    </div>

    <div class="account-tab-item__group-item-row">
      <div class="account-tab-item__sent-mob select-dropdown _left">
        <div class="account-tab-item__sent-mob-trigger" @click.prevent="showHistory = true">
          <span class="account-tab-item__label-mob">{{$tResumeList('Sent')}}</span>
          <span class="account-tab-item__sent-number">14<BaseSvg name="ico-arrow-down"/></span>
        </div>
        <transition name="dropdown">
          <div
            v-if="showHistory"
            v-click-out="() => this.showHistory = false"
            class="select-dropdown__dropdown"
          >
            <button
              type="button"
              class="select-dropdown__close"
              @click.prevent="showHistory = false"
            >
              <BaseSvg
                name="ico-close"
                width=".8rem"
                height=".8rem"
              />
            </button>

            <div class="select-dropdown__options">
              <ul class="account-tab-item__sent-history">
                <li v-for="index in 5"
                    :key="index"
                >
                  <a href="#" class="account-tab-item__sent-history-link">Работник на склад лампочек Philips во
                    Вроцлав</a>
                  <div class="account-tab-item__sent-history-date">{{$tResumeList('Sent')}} 19.12.2019</div>
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>

      <div class="account-tab-item__date"><BaseSvg name="ico-update"/>23.01.2020</div>
    </div>

    <div class="account-tab-item__group-item-row">
      <a href="#"
         class="account-tab-item__btn base-btn base-btn--outline-grey--green base-btn--small">
        <span>{{$tResumeList('Find vacancies')}}</span>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ResumeTabItemMyRow',
    props: {
      isMob: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showHistory: false,
        showTools: false
      }
    }
  }
</script>

<style>

</style>
